import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import Icon from "./icon";
export default (function (_ref) {
  var perPage = _ref.perPage,
      total = _ref.total,
      active = _ref.active,
      _onClick = _ref.onClick,
      loading = _ref.loading;
  var pages = Math.ceil(total / perPage);
  return pages > 0 && /*#__PURE__*/React.createElement(Pagination, {
    listClassName: "pagination-sm"
  }, pages > 1 && active !== 1 && /*#__PURE__*/React.createElement(PaginationItem, null, /*#__PURE__*/React.createElement(PaginationLink, {
    disabled: loading,
    onClick: function onClick() {
      return _onClick && _onClick(active - 1);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-left"
  }))), Array(pages).fill(null).map(function (o, i) {
    if (pages > 8 && i !== 0 && i !== pages - 1) {
      if (active - 5 === i || active + 3 === i) {
        return /*#__PURE__*/React.createElement(PaginationItem, {
          key: i,
          disabled: true
        }, /*#__PURE__*/React.createElement(PaginationLink, {
          className: "bg-transparent border-0"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "ellipsis-h"
        })));
      }

      if (active - 4 > i || active + 2 < i) {
        return null;
      }
    }

    return /*#__PURE__*/React.createElement(PaginationItem, {
      active: active === i + 1,
      disabled: loading,
      key: i
    }, /*#__PURE__*/React.createElement(PaginationLink, {
      onClick: function onClick() {
        return _onClick && active !== i + 1 && _onClick(i + 1);
      }
    }, i + 1));
  }), pages > 1 && active !== pages && /*#__PURE__*/React.createElement(PaginationItem, null, /*#__PURE__*/React.createElement(PaginationLink, {
    disabled: loading,
    onClick: function onClick() {
      return _onClick && _onClick(active + 1);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-right"
  }))));
});